import { useAtomValue, useSetAtom } from 'jotai';

import { closePanelAtom, panelsAtom } from '@/stores/panels';
import { ResponsivePanelWrapper } from '@/components/ui/ResponsivePanelWrapper';
import { QuickCaptureContent, CaptureData } from './QuickCaptureContent';

interface QuickCapturePanelProps {
  onSave: (data: CaptureData) => void;
}

export function QuickCapturePanel({ onSave }: QuickCapturePanelProps) {
  const panels = useAtomValue(panelsAtom);
  const closePanel = useSetAtom(closePanelAtom);

  const handleClose = () => {
    closePanel('quickCapture');
  };

  return (
    <ResponsivePanelWrapper panelId="quickCapture" title="Quick Capture">
      <QuickCaptureContent
        isOpen={panels.quickCapture.isOpen}
        onClose={handleClose}
        onSave={onSave}
      />
    </ResponsivePanelWrapper>
  );
}

export default QuickCapturePanel;
